"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var dayjs_1 = __importDefault(require("dayjs"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            marginBottom: theme.spacing(8),
        },
        week: {
            textAlign: 'center',
        },
        date: {
            display: 'inline-block',
            color: theme.palette.grey[500],
            marginLeft: theme.spacing(1),
        },
    });
});
var StudyPlanWeek = function (_a) {
    var classNameProp = _a.className, children = _a.children, week = _a.week, number = _a.number, other = __rest(_a, ["className", "children", "week", "number"]);
    var classes = exports.useStyles();
    var endDate = new Date(week.startDate.toDateString());
    endDate.setDate(endDate.getDate() + week.days.length - 1);
    var startMonth = dayjs_1.default(week.startDate).format('MMM');
    var endMonth = dayjs_1.default(endDate).format('MMM');
    var startDay = dayjs_1.default(week.startDate).format('D');
    var endDay = dayjs_1.default(endDate).format('D');
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.root, classNameProp) }, other),
        react_1.default.createElement(core_1.Typography, { gutterBottom: true, variant: "h5", className: classes.week },
            "Week ",
            number,
            ' ',
            react_1.default.createElement("span", { className: classes.date },
                startMonth,
                " ",
                startDay,
                " -",
                ' ',
                endMonth !== startMonth ? endMonth + " " : '',
                endDay)),
        children));
};
exports.default = StudyPlanWeek;
//# sourceMappingURL=StudyPlanWeek.js.map